const d3 = require("d3");
const { DashboardVisual } = require("@/visualisation/dashboard/dashboardVisual.js");

class DueDateDaysVisual extends DashboardVisual {
    constructor(svg, currData) {
        super(svg);
        
        this.initChart(currData);

    }

    getBaseOpacities() {
        return [1.0, 1.0, 1.0, 1.0];
    }

    valToString(val) {
        this.dayFormatter = Intl.NumberFormat('en', { notation: 'compact'});
        return this.dayFormatter.format(val);
      }

    getBaseColours() {
        return ["rgb(255, 102, 127)", "rgb(255, 210, 102)", "rgb(108, 218, 102)", "rgb(102, 188, 255)"];
    }

    initChart(currData) {
        super.initChart(this.getBaseOpacities(), this.getBaseColours(), currData.pieData);


        this.delayedText = this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", -45).text("2").style("font-family", "Open Sans").style("font-size", "35px").style("font-weight", "600").style("fill", "rgba(236, 74, 67, 1)");
      this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", -10).text("Days delayed").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)");

      // Add one word in the middle of the circle, with the open sans font

      this.earlyText = this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", 25).text("9").style("font-family", "Open Sans").style("font-size", "35px").style("font-weight", "600").style("fill", "rgba(110, 188, 44, 1)");
      this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", 55).text("Days earlier").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)");
        this.updateChart(currData)
    }  

    updateChart(currData) {

        this.delayedText.text(this.valToString(currData.totalDelayed));
        this.earlyText.text(this.valToString(currData.totalEarly));


        super.updatePie(currData.pieData);
    }
}

export { DueDateDaysVisual };